import axios from "axios";
import Asciidoctor from '../../../../node_modules/asciidoctor.js/dist/asciidoctor'

export const getRequest = (input) => dispatch => {

    axios.get(input).then( response => {

        const asciidoctor = Asciidoctor();
        const html = asciidoctor.convert(response.data);

      dispatch({
        type: "GET_ASCIIDOC_SUCCESS",
        results:html,
        status:response.status
      });
    }).catch(function (error) {
      dispatch({
        type: "GET_ASCIIDOC_ERROR",
        status:false
      });
    });
};

export const getMenu = () => dispatch => {

    axios.get(window.urlMenuAdocs).then( response => {
        dispatch({
            type: "GET_MENU_ASCIIDOC_SUCCESS",
            results:response.data._links,
            status:response.status
        });
    }).catch(function (error) {
        dispatch({
            type: "GET_MENU_ASCIIDOC_ERROR",
            status:false
        });
    });
};

